import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createProduct,
  deleteProduct,
  getAllProduct,
  updateProduct
} from "../../State/Product/Action";
import {
  Button,
  Grid,
  TextField,
  Typography,
  Card,
  CardHeader,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  CardContent,
  IconButton,
  Tooltip,
  CircularProgress,
  Autocomplete,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { toast } from "react-toastify";
import { getAllCategory } from "../../../User/State/Category/Action";
import { DataGrid } from "@mui/x-data-grid";
import { AddCircle, Delete, Edit, FileDownload, ContentCopy, Print, Visibility } from "@mui/icons-material";
import VariantModal from "../../Components/AddProduct/VariantModal";
import ImageModal from "../../Components/AddProduct/ImageModal";
import ProductDetailsModal from "../../Components/AddProduct/ProductDetailsModal";
import ColorModal from "../../Components/AddProduct/ColorModal";
import { Add as AddIcon } from "@mui/icons-material"; // import AddIcon
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import { getAllBrand } from "../../../Admin/State/Brand/Action";
import ImagePopup from "../../../Common/ImagePopup";
import defaultImage from "../../../Common/productDefaultImage.png"
import ProductManageModal from "../../../Admin/Components/AddProduct/ProductManageModal";

const AddProduct = () => {
  const { vendorProducts, publicCategory, brands } = useSelector(
    (store) => store
  ); // eslint-disable-line no-unused-vars
  const [productData, setProductData] = useState({
    title: "",
    description: "",
    categoryId: "",
    subCategoryId: "",
    productCategoryId: "",
    brandName: "",
    gst: "",
    returnAllowed: false,
    customizationAllowed: false, // ✅ default false
    customizationPrice: 0, // ✅ default 0
  });
  const [editingId, setEditingId] = useState(null);
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(0);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [openVariantModal, setOpenVariantModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // Move search query state here
  // Add this state for selection
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [gstValue, setGstValue] = useState(0);

  const [imageOpen, setImageOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  // Add state for modal
  const [openAddProductModal, setOpenAddProductModal] = useState(false);

  const [productVariants, setProductVariants] = useState(null);
  const handleVariantOpen = (product) => { setOpenVariantModal(true); setProductVariants(product) }
  const handleVariantClose = () => { setProductVariants(null); setOpenVariantModal(false); }

  const [openImageModal, setOpenImageModal] = useState(false);
  const [productImages, setProductImages] = useState(null);
  const handleImageOpen = (product) => { setOpenImageModal(true); setProductImages(product) }
  const handleImageClose = () => { setProductImages(null); setOpenImageModal(false); }

  const [openColorModal, setOpenColorModal] = useState(false);
  const [productColors, setProductColors] = useState(null);
  const handleColorOpen = (product) => { setOpenColorModal(true); setProductColors(product) }
  const handleColorClose = () => { setProductColors(null); setOpenColorModal(false); }

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);

  const handleViewProduct = (product) => {
    setSelectedProduct(product);
    setOpenDetails(true);
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
    setSelectedProduct(null);
  };

  // add full product details
  const [openManageModal, setOpenManageModal] = useState(false);
  const [editData, setEditData] = useState(null);

  // const brandOptions = React.useMemo(() => {
  //   return Array.isArray(brands?.brands?.response)
  //     ? brands.brands.response.map((b) => b.name)
  //     : [];
  // }, [brands]);

  const brandOptions = React.useMemo(() => {
    if (!Array.isArray(brands?.brands?.response)) return [];
    return brands.brands.response
      .map((b) => b?.name)
      .filter(Boolean); // null / undefined remove
  }, [brands]);

  const safeBrandValue =
    typeof productData.brandName === "string"
      ? productData.brandName
      : "";

  const handleCategoryClick = (categoryId) => {
    setSelectedCategoryId(categoryId);
  };

  const handleSubCategoryClick = (subCategoryId) => {
    setSelectedSubCategoryId(subCategoryId);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "gst" && !/^\d*$/.test(value)) return;
    if (name === "customizationPrice" && !/^\d*$/.test(value)) return;
    setProductData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setProductData((prev) => {
      // सिर्फ customizationAllowed पे ही customizationPrice को छेड़ना है
      if (name === "customizationAllowed") {
        return {
          ...prev,
          [name]: checked,
          customizationPrice: checked ? prev.customizationPrice || 0 : 0,
        };
      }

      // बाकी checkboxes (जैसे returnAllowed) पे सिर्फ वही value update होगी
      return {
        ...prev,
        [name]: checked,
      };
    });
  };


  useEffect(() => {
    dispatch(getAllCategory());
    dispatch(getAllProduct());
    dispatch(getAllBrand());
  }, [dispatch, openAddProductModal]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      productData.title?.trim() === "" ||
      productData.description?.trim() === "" ||
      productData.brandName?.trim() === "" ||
      productData.categoryId === "" ||
      productData.subCategoryId === "" ||
      productData.productCategoryId === ""
    ) {
      toast.error("Please fill all the fields");
      return;
    }

    if (productData.title?.length < 3 || productData.title?.length > 200) {
      toast.error("Product title should be between 3 to 200 characters");
      return;
    }

    if (
      productData.description?.length < 3 ||
      productData.description?.length > 2000
    ) {
      toast.error("Product description should be between 3 to 2000 characters");
      return;
    }

    if (
      productData.brandName?.length < 3 ||
      productData.brandName?.length > 100
    ) {
      toast.error("Product Brand Name should be between 3 to 100 characters");
      return;
    }
    // ✅ ensure customizationPrice is number (default 0 if empty)
    const payload = {
      ...productData,
      customizationPrice:
        productData.customizationAllowed && productData.customizationPrice
          ? Number(productData.customizationPrice)
          : 0,
    };

    if (editingId) {
      dispatch(updateProduct(editingId, payload, handleCancle));
    } else {
      dispatch(createProduct(payload, handleCancle));
    }
  };


  const confirmDelete = () => {
    dispatch(deleteProduct(productToDelete, setOpenDialog));
    setProductToDelete(null);
  };

  const handleDeleteClick = (id) => {
    setProductToDelete(id);
    setOpenDialog(true);
  };

  const handleUpdateClick = (item) => {
    setEditData(item);
    setOpenManageModal(true)
    // setProductData({
    //   title: item.title,
    //   description: item.description,
    //   categoryId: item.category.id,
    //   subCategoryId: item.subCategory.id,
    //   productCategoryId: item.productCategory.id,
    //   brandName: item.brand.name,
    //   gst: item.igst,
    //   returnAllowed: item?.returnAllowed?.toLowerCase() === "yes" ? true : false,
    //   customizationAllowed: item?.customizationAllowed,
    //   customizationPrice: item?.customizationPrice
    // });
    // setGstValue(item.igst)
    // setEditingId(item.id);
    // setSelectedCategoryId(item.category.id)
    // setSelectedSubCategoryId(item.subCategory.id)
    // setOpenAddProductModal(true);
  };

  const handleCancle = () => {
    setProductData({
      title: "",
      description: "",
      categoryId: "",
      subCategoryId: "",
      productCategoryId: "",
      brandName: "",
      gst: "",
      returnAllowed: false,
      customizationAllowed: false,
      customizationPrice: 0,
    });
    setGstValue(0)
    setEditingId(null);
    setSelectedCategoryId(null)
    setSelectedSubCategoryId(null)
    setOpenAddProductModal(false);
  }

  const columns = [
    {
      field: "serialNo",
      headerName: "S.No.",
      width: 70,
      sortable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1
    },
    { field: "productId", headerName: "Product ID", width: 110 },
    { field: "title", headerName: "Title", width: 180 },
    {
      field: "brand",
      headerName: "Brand",
      width: 120,
    },
    {
      field: "categoryHyrarchy",
      headerName: "Category",
      width: 200,
    },
    {
      field: "color",
      headerName: "Color",
      width: 150,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={0.5} pt={0} sx={{ padding: 0, minHeight: 0 }}>
          {/* {params.row.productStatus !== "APPROVED" && (
            <AddCircle
              fontSize="small"
              color="primary"
              sx={{ cursor: "pointer", fontSize: 16, p: 0, m: 0 }}
              onClick={() => handleColorOpen(params.row.fullProduct)}
            />
          )} */}
          <Typography variant="body2" sx={{ fontSize: "0.8rem", p: 0, m: 0 }}>{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "variants",
      headerName: "Variant Sizes",
      width: 200,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={0.5} pt={0} sx={{ padding: 0, minHeight: 0 }}>
          {/* {params.row.productStatus !== "APPROVED" && params?.row?.fullProduct?.colors?.length > 0 && (
            <AddCircle
              fontSize="small"
              color="primary"
              sx={{ cursor: "pointer", fontSize: 16, p: 0, m: 0 }}
              onClick={() => handleVariantOpen(params.row.fullProduct)}
            />
          )} */}

          <Typography variant="body2" sx={{ fontSize: "0.8rem", p: 0, m: 0 }}>{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "images",
      headerName: "Images",
      width: 180,
      renderCell: (params) => {
        const images = params.row?.images || [];
        const primaryImages = images.filter((img) => img.isPrimary);
        const otherImages = images.filter((img) => !img.isPrimary);

        return (
          <Box display="flex" alignItems="center" gap={0.5} pt={0} sx={{ padding: 0, minHeight: 0 }}>
            {/* {params.row.productStatus !== "APPROVED" && params?.row?.fullProduct?.colors?.length > 0 && (
              <AddCircle
                fontSize="small"
                color="primary"
                sx={{ cursor: "pointer", fontSize: 16, p: 0, m: 0 }}
                onClick={() => handleImageOpen(params.row.fullProduct)}
              />
            )} */}

            {/* Primary image - slightly bigger */}
            {primaryImages.map((img, index) => (
              <Box
                key={index}
                component="img"
                src={img.fullUrl || defaultImage}
                alt={`Primary ${index + 1}`}
                sx={{
                  width: 30,
                  height: 30,
                  objectFit: "cover",
                  borderRadius: 1,
                  border: "2px solid #1976d2",
                  cursor: "pointer"
                }}
                onClick={() => { setImageOpen(true); setImageUrl(img?.fullUrl || defaultImage) }}
              />
            ))}

            {/* Other images - smaller */}
            {otherImages.slice(0, 2).map((img, index) => ( // Show max 2 other images
              <Box
                key={index}
                component="img"
                src={img.fullUrl || defaultImage}
                alt={`Variant ${index + 1}`}
                sx={{
                  width: 20,
                  height: 20,
                  objectFit: "cover",
                  borderRadius: 1,
                  opacity: 0.8,
                  cursor: "pointer"
                }}
                onClick={() => { setImageOpen(true); setImageUrl(img?.fullUrl || defaultImage) }}
              />
            ))}
            {otherImages.length > 2 && (
              <Typography variant="body2" sx={{ fontSize: "0.7rem", ml: 0.5 }}>
                +{otherImages.length - 2}
              </Typography>
            )}
          </Box>
        );
      },
    }
    ,
    { field: "igst", headerName: "GST", width: 100, renderCell: (params) => (params.value ? ("IGST - " + params.row.igst + "% , CGST - " + params.row.cgst + "% , SGST - " + params.row.sgst + "%") : "----") },
    { field: "vendorPrices", headerName: "Prices", width: 120 },
    { field: "returnAllowed", headerName: "Return Allowed", width: 120 },
    { field: "customizationAllowed", headerName: "Customization Allowed", width: 120 },
    { field: "customizationPrice", headerName: "Customization Price", width: 120 },
    {
      field: "productStatus",
      headerName: "Status",
      width: 100,
      renderCell: (params) => (
        <span
          className="text-white rounded-full"
          style={{
            fontSize: "0.75rem",
            padding: "2px 8px",
            minWidth: 60,
            display: "inline-block",
            textAlign: "center",
            background:
              params.value === "APPROVED"
                ? "#369236"
                : params.value === "REJECT"
                  ? "#36FD56"
                  : params.value === "PENDING"
                    ? "gray"
                    : "#592545",
            color: "#fff",
            fontWeight: 500,
            borderRadius: "12px",
          }}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: "fullProduct",
      headerName: "View Details",
      width: 60,
      renderCell: (params) => (
        <IconButton
          size="small"
          color="primary"
          sx={{ p: 0, m: 0, cursor: "pointer" }}
          onClick={() => handleViewProduct(params.row.fullProduct)}
        >
          <Visibility fontSize="small" sx={{ fontSize: 18, cursor: "pointer" }} />
        </IconButton>
      ),
    },
    {
      field: "actions",
      headerName: "Action",
      width: 80,
      renderCell: (params) => (
        <Box display="flex" gap={0} sx={{ p: 0, m: 0, minHeight: 0 }}>
          <Tooltip title="Edit">
            <IconButton
              size="small"
              sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
              onClick={() => handleUpdateClick(params.row.fullProduct)}
            >
              <Edit fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              color="error"
              size="small"
              sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
              onClick={() => handleDeleteClick(params.row.id)}
              disabled={params.row.productStatus === "APPROVED"}
            >
              <Delete fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
            </IconButton>
          </Tooltip>
        </Box>
      )
    }
  ];

  const rows =
    vendorProducts?.products?.response?.map((product, index) => ({
      id: product?.id,
      productId: product?.productId,
      title: product?.title,
      description: product?.description,
      brand: product?.brand?.name,
      color: product?.colors?.map((color) => color?.color?.name)?.join(", ") || "----",
      variants: [...new Set(product.variants?.map(v => v?.size?.name))].join(", ") || "----",
      vendorPrices: product.variants?.map((v) => v?.vendorPrice?.toFixed(2)).join(", ") || 0.0,
      images: product?.images || "----",
      category: product?.category?.name,
      subCategory: product?.subCategory?.name,
      productCategory: product?.productCategory?.name,
      categoryHyrarchy: `${product.category?.name || ""} - ${product.subCategory?.name || ""
        } - ${product.productCategory?.name || ""}`,
      productStatus: product?.productStatus,
      cgst: product?.cgst,
      sgst: product?.sgst,
      igst: product?.igst,
      returnAllowed: product?.returnAllowed,
      customizationAllowed: product?.customizationAllowed ? "Yes" : "NO",
      customizationPrice: product.customizationAllowed ? product?.customizationPrice : "....",
      createdAt: product?.createdAt,
      fullProduct: product
    })) || [];

  // Filtered rows for search functionality
  const filteredRows = rows.filter((row) => {
    const query = searchQuery.toLowerCase();

    // boolean values ko human-readable banाओ ("Yes"/"No")
    const customizationAllowedText = row.customizationAllowed ? "yes" : "no";
    const returnAllowedText = row.returnAllowed ? "yes" : "no";

    // number value ko string me convert कर दो
    const customizationPriceText = row.customizationPrice?.toString() || "0";

    return (
      row.title?.toLowerCase().includes(query) ||
      row.brand?.toLowerCase().includes(query) ||
      row.categoryHyrarchy?.toLowerCase().includes(query) ||
      row.color?.toLowerCase().includes(query) ||
      row.variants?.toLowerCase().includes(query) ||
      row.status.toLowerCase().includes(query) ||
      customizationAllowedText.includes(query) || // ✅ "yes"/"no"
      returnAllowedText.includes(query) ||        // ✅ "yes"/"no"
      customizationPriceText.includes(query)      // ✅ price numeric search
    );
  });


  const getExportData = () => {
    // If some rows are selected, filter them; else use all filteredRows
    if (selectedRowIds.length > 0) {
      return filteredRows.filter((row) => selectedRowIds.includes(row.id));
    }
    return filteredRows;
  };


  // Export, Copy, and Print Handlers
  const handleExportCSV = () => {
    const exportRows = getExportData(); // ✅ Call the function
    const csvContent = exportRows.map((row, index) => {
      return [
        index + 1,
        row.id,
        row.title,
        row.brand,
        row.categoryHyrarchy || row.category,
        row.color,
        row.variants,
        row.igst,
        row.vendorPrices,
        row.returnAllowed,
        row.customizationAllowed,
        row.customizationPrice,
        row.productStatus
      ].join(',');
    }).join('\n');

    const headers = [
      'S.No.',
      'Product ID',
      'Title',
      'Brand',
      'Category',
      'Color',
      'Variants',
      'GST',
      'Actual Prices',
      'Return Allowed',
      'Customization Allowed',
      'Customization Price',
      'Status'
    ].join(',');

    const csv = `${headers}\n${csvContent}`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'products.csv';
    link.click();
  };

  const handleExportPDF = () => {
    const exportRows = getExportData(); // ✅ Call the function
    const doc = new jsPDF({
      orientation: "landscape", // wider layout
      unit: "pt",                // use points for precision
      format: "a3",              // bigger page to fit all columns
    });

    doc.setFontSize(14);
    doc.text("Product List", 40, 30);

    const tableColumn = [
      'S.No.',
      'Product ID',
      'Title',
      'Brand',
      'Category',
      'Color',
      'Variants',
      'GST',
      'Actual Prices',
      'Return Allowed',
      'Customization Allowed',
      'Customization Price',
      'Status'
    ];

    const tableRows = [];

    exportRows.forEach((row, index) => {
      const productData = [
        index + 1,
        row.id,
        row.title,
        row.brand,
        row.categoryHyrarchy || row.category,
        row.color,
        row.variants,
        row.igst,
        row.vendorPrices,
        row.returnAllowed,
        row.customizationAllowed,
        row.customizationPrice,
        row.productStatus
      ];
      tableRows.push(productData);
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 40,
      theme: 'striped',
      headStyles: {
        fillColor: [37, 99, 235], // Tailwind blue-600 (RGB: 37,99,235)
        textColor: [255, 255, 255], // white text
        halign: 'left',
      },
      styles: {
        fontSize: 9,
        cellPadding: 4,
        overflow: 'linebreak',
      },
      didDrawPage: (data) => {
        doc.setFontSize(10);
        doc.text(`Generated on ${new Date().toLocaleString()}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
      }
    });

    doc.save('products.pdf');
  };

  const handlePrint = () => {
    const exportRows = getExportData(); // ✅ Call the function
    const printWindow = window.open('', '_blank');
    const headers = [
      'S.No.',
      'Product ID',
      'Title',
      'Brand',
      'Category',
      'Color',
      'Variants',
      'GST',
      'Actual Price',
      'Return Allowed',
      'Customization Allowed',
      'Customization Price',
      'Status'
    ];

    const tableContent = exportRows.map((row, index) => [
      index + 1,
      row.id,
      row.title,
      row.brand,
      row.categoryHyrarchy || row.category,
      row.color,
      row.variants,
      row.igst,
      row.vendorPrices,
      row.returnAllowed,
      row.customizationAllowed,
      row.customizationPrice,
      row.productStatus
    ]);

    const html = `
      <html>
        <head>
          <title>Products List</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid black; padding: 8px; text-align: left; }
            th {background: #449AEF;
                color: white;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact; }
            tr:nth-child(even) { background-color: #f5f5f5; }
          </style>
        </head>
        <body>
          <h2>Products List</h2>
          <table>
            <thead>
              <tr>
                ${headers.map(header => `<th>${header}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${tableContent.map(row => `
                <tr>
                  ${row.map(cell => `<td>${cell}</td>`).join('')}
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div>
      <Box ref={formRef} />

      {/* Products Card */}
      <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
        <CardHeader
          title={
            <Typography variant="h6" className="text-gray-700">
              PRODUCTS
            </Typography>
          }
          action={
            <Box display="flex" alignItems="center">
              <Button
                variant="contained"
                sx={{
                  minWidth: 0,
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  background: "linear-gradient(90deg, #449AEF 0%, #f87171 100%)",
                  color: "#fff",
                  boxShadow: "0 2px 8px rgba(239,68,68,0.15)",
                  mr: 1.2,
                  p: 0,
                  "&:hover": {
                    background: "linear-gradient(90deg, #f87171 0%, #449AEF 100%)",
                    boxShadow: "0 4px 16px rgba(239,68,68,0.25)",
                    transform: "scale(1.08)",
                  },
                }}
                onClick={() => {
                  setEditData(null);
                  setOpenManageModal(true)
                }}
              // onClick={() => {
              //   setOpenAddProductModal(true);
              //   setEditingId(null);
              // }}
              >
                <AddIcon sx={{ fontSize: 22 }} />
              </Button>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, color: "#449AEF", fontSize: "1rem", letterSpacing: 0.2 }}
              >
                Add Product
              </Typography>
            </Box>
          }
        />
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', mb: 2 }}>
            {/* Buttons */}
            <Box sx={{ display: 'flex', gap: 1.5, mb: { xs: 2, sm: 0 } }}>
              <Button
                variant="contained"
                startIcon={<FileDownload />}
                onClick={handleExportCSV}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Export CSV
              </Button>
              <Button
                variant="contained"
                startIcon={<ContentCopy />}
                onClick={handleExportPDF}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Export PDF
              </Button>
              <Button
                variant="contained"
                startIcon={<Print />}
                onClick={handlePrint}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Print
              </Button>
            </Box>
            {/* Search Box */}
            <Box>
              <TextField
                label="Search Products"
                variant="outlined"
                size="small"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{ width: { xs: '100%', sm: '300px' } }}
              />
            </Box>
          </Box>
          <Box sx={{ height: "100%", width: "100%" }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pagination
              initialState={{
                pagination: { paginationModel: { pageSize: 10, page: 0 } },
              }}
              pageSizeOptions={[10, 25, 50, 75, 100]}
              checkboxSelection           // ✅ Enable checkbox selection
              onRowSelectionModelChange={(ids) => setSelectedRowIds(ids)} // Track selection
              selectionModel={selectedRowIds} // selected mode
              disableSelectionOnClick
              autoHeight={true}
              density="compact"
              experimentalFeatures={{ virtualization: true }}
              loading={vendorProducts.loading}
              sx={{
                borderRadius: 2,
                fontSize: "0.8rem",
                "& .MuiDataGrid-cell": {
                  fontSize: "0.8rem",
                  border: "1px solid rgb(204, 201, 201)",
                  minHeight: "36px !important",
                  height: "36px !important",
                  lineHeight: "1.2",
                  paddingTop: "4px",
                  paddingBottom: "4px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "#449AEF",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "0.8rem",
                  border: "1px solid rgb(204, 201, 201)",
                  minHeight: "36px !important",
                  height: "36px !important",
                  lineHeight: "1.2",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontSize: "0.8rem",
                  fontWeight: 600,
                },
                "& .MuiDataGrid-row": {
                  maxHeight: "36px !important",
                  minHeight: "36px !important",
                },
                "& .MuiDataGrid-row:nth-of-type(odd)": {
                  backgroundColor: "#f5f5f5",
                },
                "& .MuiDataGrid-row:nth-of-type(even)": {
                  backgroundColor: "#ffffff",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
              getRowId={(row) => row.id}
            />
          </Box>
        </CardContent>
      </Card>


      {/* Modals */}
      <ColorModal open={openColorModal} onClose={handleColorClose} row={productColors} loading={vendorProducts.loading} />
      <VariantModal open={openVariantModal} onClose={handleVariantClose} row={productVariants} loading={vendorProducts.loading} />
      <ImageModal open={openImageModal} onClose={handleImageClose} row={productImages} loading={vendorProducts.loading} />
      <ProductDetailsModal open={openDetails} onClose={handleCloseDetails} row={selectedProduct} />

      {/* Replace the form rendering with a Dialog: */}
      <Dialog
        open={openAddProductModal}
        onClose={handleCancle}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", fontSize: "1.25rem", fontWeight: "bold", mt: 1, mb: 0.5, pb: 1, borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
          {editingId ? "UPDATE PRODUCT" : "ADD NEW PRODUCT"}
        </DialogTitle>
        <DialogContent sx={{ px: 2, py: 1 }}>
          <Card className="mb-4" sx={{ borderRadius: 2, boxShadow: 1 }}>
            <CardContent sx={{ p: 2 }}>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={1.5}>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      fullWidth
                      label="Product Title"
                      name="title"
                      size="small"
                      value={productData.title}
                      onChange={handleChange}
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          transition: "all 0.2s ease-in-out",
                          "&:hover fieldset": {
                            borderColor: "#449AEF",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#449AEF",
                          },
                        },
                      }}
                    />
                  </Grid>


                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      label="Product Description"
                      size="small"
                      name="description"
                      value={productData.description}
                      onChange={handleChange}
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          transition: "all 0.2s ease-in-out",
                          "&:hover fieldset": {
                            borderColor: "#449AEF",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#449AEF",
                          },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <FormControl size="small" fullWidth variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          transition: "all 0.2s ease-in-out",
                          "&:hover fieldset": {
                            borderColor: "#449AEF",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#449AEF",
                          },
                        },
                      }}
                    >
                      <InputLabel>Category</InputLabel>
                      <Select
                        name="categoryId"
                        size="small"
                        label="Category"
                        value={productData.categoryId}
                        onChange={handleChange}
                      >
                        <MenuItem value={0} disabled>Select Category...</MenuItem>
                        {publicCategory?.categories?.response
                          ?.filter((category) => category?.name?.toLowerCase() !== "designer" &&
                            category?.name?.toLowerCase() !== "designers") // hide 'designer'
                          .map(
                            (category) =>
                              category && (
                                <MenuItem
                                  key={category.id}
                                  value={category.id}
                                  onClick={() => handleCategoryClick(category.id)}
                                >
                                  {category?.name}
                                </MenuItem>
                              )
                          )}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <FormControl size="small" fullWidth variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          transition: "all 0.2s ease-in-out",
                          "&:hover fieldset": {
                            borderColor: "#449AEF",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#449AEF",
                          },
                        },
                      }}
                    >
                      <InputLabel>Sub Category</InputLabel>
                      <Select
                        name="subCategoryId"
                        size="small"
                        label="Sub Category"
                        value={productData.subCategoryId}
                        onChange={handleChange}
                      >
                        <MenuItem value={0} disabled>Select Sub Category...</MenuItem>
                        {publicCategory?.categories?.response
                          ?.filter((category) => category.id === selectedCategoryId)
                          .flatMap((category) =>
                            category.subCategories
                              ?.filter((subCategory) => subCategory.name.toLowerCase() !== "designer" &&
                                subCategory.name.toLowerCase() !== "designers") // <-- filter out 'designer'
                              .map((subCategory) => (
                                <MenuItem
                                  key={subCategory.id}
                                  value={subCategory.id}
                                  onClick={() => handleSubCategoryClick(subCategory.id)}
                                >
                                  {subCategory.name}
                                </MenuItem>
                              ))
                          )}

                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small" variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          transition: "all 0.2s ease-in-out",
                          "&:hover fieldset": {
                            borderColor: "#449AEF",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#449AEF",
                          },
                        },
                      }}
                    >
                      <InputLabel>Product Category</InputLabel>
                      <Select
                        name="productCategoryId"
                        label="Product Category"
                        value={productData.productCategoryId}
                        onChange={handleChange}
                      >
                        <MenuItem value={0} disabled>Select Product Category...</MenuItem>
                        {publicCategory?.categories?.response?.flatMap((category) =>
                          category.subCategories
                            ?.filter(
                              (subCategory) => subCategory.id === selectedSubCategoryId
                            )
                            .flatMap((subCategory) =>
                              subCategory.productCategories?.map((productCategory) => (
                                <MenuItem
                                  key={productCategory.id}
                                  value={productCategory.id}
                                >
                                  {productCategory.name}
                                </MenuItem>
                              ))
                            )
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Autocomplete
                      freeSolo
                      disableClearable
                      options={brandOptions}
                      value={safeBrandValue}

                      // 🔥 MOST IMPORTANT (live crash fix)
                      filterOptions={(options) => options ?? []}

                      noOptionsText="No brands available"

                      onChange={(event, newValue) => {
                        setProductData((prev) => ({
                          ...prev,
                          brandName: newValue || ""
                        }));
                      }}

                      onInputChange={(event, newInputValue) => {
                        if (event) {
                          setProductData((prev) => ({
                            ...prev,
                            brandName: newInputValue || ""
                          }));
                        }
                      }}

                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Brand Name"
                          size="small"
                          fullWidth
                          placeholder="Enter or select brand"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "#e5e7eb"
                              },
                              "&:hover fieldset": {
                                borderColor: "#ef4444"
                              }
                            }
                          }}
                        />
                      )}
                    // freeSolo // ✅ allows typing new brand
                    // options={brandOptions} // show all brand names
                    // value={productData.brandName || ""}
                    // filterOptions={(options) => options} // ✅ prevent internal crash
                    // noOptionsText="No brands found"
                    // onChange={(event, newValue) => {
                    //   setProductData((prev) => ({
                    //     ...prev,
                    //     brandName: newValue || "" // set dropdown value
                    //   }));
                    // }}
                    // onInputChange={(event, newInputValue) => {
                    //   setProductData((prev) => ({
                    //     ...prev,
                    //     brandName: newInputValue // set typed value
                    //   }));
                    // }}
                    // renderInput={(params) => (
                    //   <TextField
                    //     {...params}
                    //     label="Brand Name"
                    //     size="small"
                    //     fullWidth
                    //     sx={{
                    //       "& .MuiOutlinedInput-root": {
                    //         "& fieldset": {
                    //           borderColor: "#e5e7eb"
                    //         },
                    //         "&:hover fieldset": {
                    //           borderColor: "#449AEF",
                    //         }
                    //       }
                    //     }}
                    //   />
                    // )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      fullWidth
                      label="GST (%)"
                      size="small"
                      name="gst"
                      value={productData.gst}
                      onChange={handleChange}
                      disabled={editingId && gstValue > 0}
                      variant="outlined"
                      inputProps={{ maxLength: 2 }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          transition: "all 0.2s ease-in-out",
                          "&:hover fieldset": {
                            borderColor: "#449AEF",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#449AEF",
                          },
                        },
                      }}
                    />
                  </Grid>
                  {/* ✅ Return & Exchange checkboxes */}
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="returnAllowed"
                          checked={productData.returnAllowed}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="Return Allowed"
                    />
                  </Grid>
                  {/* 🔹 Checkbox for customization */}
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="customizationAllowed"
                          checked={productData.customizationAllowed}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label="Customization Allowed"
                    />
                  </Grid>
                  {/* 🔹 Show price only if customization allowed */}
                  {productData.customizationAllowed && (
                    <Grid item xs={12} sm={6} md={4}>
                      <TextField
                        fullWidth
                        name="customizationPrice"
                        label="Customization Price"
                        size="small"
                        value={productData.customizationPrice}
                        onChange={handleChange}
                        variant="outlined"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            transition: "all 0.2s ease-in-out",
                            "&:hover fieldset": {
                              borderColor: "#449AEF",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#449AEF",
                            },
                          },
                        }}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4 }}>
                    <Button
                      variant="contained"
                      type="submit"
                      disabled={vendorProducts.loading}
                      sx={{
                        background: "linear-gradient(90deg, #449AEF 0%, #f87171 100%)",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        borderRadius: "6px",
                        boxShadow: "0 2px 8px rgba(239,68,68,0.15)",
                        px: 2.5,
                        py: 0.8,
                        transition: "all 0.2s",
                        "&:hover": {
                          background: "linear-gradient(90deg, #f87171 0%, #449AEF 100%)",
                          boxShadow: "0 4px 16px rgba(239,68,68,0.25)",
                          transform: "scale(1.02)",
                        },
                        width: { xs: "100%", sm: "auto" },
                        textAlign: "center"
                      }}
                    >
                      {vendorProducts.loading ? (
                        <>
                          <CircularProgress size={20} sx={{ mr: 1 }} />
                          Processing...
                        </>
                      ) : (editingId ? "Update Product" : "Add Product")}
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleCancle}
                      sx={{
                        color: "#449AEF",
                        borderColor: "#449AEF",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        borderRadius: "6px",
                        px: 2.5,
                        py: 0.8,
                        transition: "all 0.2s",
                        "&:hover": {
                          backgroundColor: "#449AEF",
                          color: "#fff",
                          borderColor: "#449AEF",
                          boxShadow: "0 2px 8px rgba(239,68,68,0.1)",
                        },
                        width: { xs: "100%", sm: "auto" },
                        textAlign: "center"
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>
      <Dialog open={openDialog} onClose={() => { setOpenDialog(false) }} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this Product?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenDialog(false) }}>Cancel</Button>
          <Button onClick={confirmDelete} color="error" disabled={vendorProducts.loading}>
            {vendorProducts.loading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                Processing...
              </>
            ) : ("Delete")}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Common Popup */}
      <ImagePopup
        open={imageOpen}
        onClose={() => setImageOpen(false)}
        imageUrl={imageUrl}
      />
      {/* add manage product modal  */}
      <ProductManageModal
        open={openManageModal}
        onClose={() => { setOpenManageModal(false); setEditData(null); }}
        editData={editData}
      />
    </div>
  );
};

export default AddProduct;